import { z } from 'zod';

export const TempUserZod = z.object({
    email: z.string(),
    awsId: z.string(),
    accessToken: z.string(),
    idToken: z.string(),
    refreshToken: z.string(),
});
export type TempUser = z.infer<typeof TempUserZod>;
